<template>
  <base-container style="height: 100%">
    <el-container>
      <el-header class="align-right" style="height:30px;">
        <el-radio-group size="mini" v-model="formType">
          <el-radio-button label="add">新增表单</el-radio-button>
          <el-radio-button label="edit">编辑表单</el-radio-button>
        </el-radio-group>
      </el-header>
      <el-main>
        <ArtisanForm class="back-white" :columns="columns" v-model="formData"></ArtisanForm>
      </el-main>
    </el-container>
  </base-container>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          columns: [],
        };
      },
    },
  },
  data() {
    return {
      formType: "add",
      formData: {},
    };
  },
  computed: {
    columns() {
      return this.formType == "add"
        ? this.value.columns.filter((c) => c.isValid && c.isAdd)
        : this.value.columns.filter((c) => c.isValid && c.isEdit);
    },
  },
};
</script>

<style>
</style>